import Component from '@glimmer/component';

interface ComponentArgs {
  horizontalPosition?: string; // default 'auto-right'
  dropdownContentClass?: string; // 'tw-z-1100' can be used when the component is in a <Modal /> component
  dropdownContentMarginTopClass?: string; // default 'mt-2'
  onYes: () => void;
}

export default class DeleteConfirmationComponent extends Component<ComponentArgs> {
  get horizontalPosition() {
    return this.args.horizontalPosition || 'auto-right';
  }

  get dropdownContentMarginTopClass() {
    return this.args.dropdownContentMarginTopClass || 'mt-2';
  }
}
